import { useState } from "react";
import { motion } from "framer-motion";
import { Menu, X } from "lucide-react";
import { useLang } from "@/i18n";

export const Header = () => {
  const { lang, setLang, t } = useLang();
  const [open, setOpen] = useState(false);

  const links = [
    { id: "about", label: t("nav.about") },
    { id: "destinations", label: t("nav.ports") },
    { id: "routes", label: t("nav.routes") },
    { id: "tracking", label: t("nav.tracking") },
    { id: "billing", label: t("nav.billing") },
  ];

  const go = (id) => {
    setOpen(false);
    document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <motion.header
      initial={{ y: -80 }}
      animate={{ y: 0 }}
      transition={{ duration: 0.8, ease: [0.22, 1, 0.36, 1] }}
      className="glass-header fixed top-0 left-0 right-0 z-50"
      data-testid="site-header"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-12 h-20 flex items-center justify-between">
        <button onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })} className="flex items-center gap-3 group" data-testid="header-logo">
          <span className="w-10 h-10 bg-white flex items-center justify-center rounded-sm p-1 shadow-[0_0_22px_rgba(45,212,160,0.4)] transition-transform duration-300 group-hover:-translate-y-0.5">
            <img src="/logo.png" alt="Sodimax Logistics" className="w-full h-full object-contain" />
          </span>
          <span className="font-display font-semibold tracking-wide text-lg uppercase">Sodimax Logistics</span>
        </button>

        <nav className="hidden lg:flex items-center gap-10">
          {links.map((l) => (
            <button key={l.id} onClick={() => go(l.id)} data-testid={`nav-${l.id}`}
              className="text-sm text-steel-400 hover:text-white transition-colors duration-300 tracking-wide uppercase">
              {l.label}
            </button>
          ))}
        </nav>

        <div className="hidden lg:flex items-center gap-6">
          <div className="flex items-center text-xs font-bold tracking-widest" data-testid="lang-toggle">
            <button onClick={() => setLang("fr")} data-testid="lang-fr"
              className={`px-2 py-1 transition-colors duration-300 ${lang === "fr" ? "text-ember" : "text-steel-500 hover:text-white"}`}>FR</button>
            <span className="text-steel-600">/</span>
            <button onClick={() => setLang("en")} data-testid="lang-en"
              className={`px-2 py-1 transition-colors duration-300 ${lang === "en" ? "text-ember" : "text-steel-500 hover:text-white"}`}>EN</button>
          </div>
          <button onClick={() => go("quote")} data-testid="nav-quote-cta"
            className="bg-ember hover:bg-emberdark text-white text-sm font-semibold px-6 py-2.5 rounded-sm transition-all duration-300 hover:-translate-y-0.5">
            {t("nav.quote")}
          </button>
        </div>

        <button className="lg:hidden text-white" onClick={() => setOpen(!open)} data-testid="mobile-menu-btn">
          {open ? <X size={24} /> : <Menu size={24} />}
        </button>
      </div>

      {open && (
        <div className="lg:hidden border-t border-white/10 px-6 py-6 space-y-4 bg-abyss/95" data-testid="mobile-menu">
          {links.map((l) => (
            <button key={l.id} onClick={() => go(l.id)} className="block text-steel-300 uppercase text-sm tracking-wide">{l.label}</button>
          ))}
          <button onClick={() => go("quote")} className="block w-full bg-ember text-white font-semibold px-6 py-3 rounded-sm">{t("nav.quote")}</button>
          <div className="flex gap-4 pt-2 text-xs font-bold">
            <button onClick={() => setLang("fr")} className={lang === "fr" ? "text-ember" : "text-steel-500"}>FR</button>
            <button onClick={() => setLang("en")} className={lang === "en" ? "text-ember" : "text-steel-500"}>EN</button>
          </div>
        </div>
      )}
    </motion.header>
  );
};
